<form class="f-col blank-form">
  <div class="section-heading">
    <h2 class="h2-heading">{{content?.['b2b.managetraveler.dependentdetails']}} <div class="dot">.</div> <span class="optional">{{content?.['b2b.managetraveler.optional']}}</span> </h2>
    <a role="button" tabindex="0" class="link" *ngIf="Loader.isLists"
      (click)="navigateToForm()"><mat-icon fontSet="material-symbols-outlined" class="edit-icon">add</mat-icon> {{content?.['b2b.managetraveler.addnewdependent']}}</a>
  </div>
  <ng-container [ngSwitch]="Loader.STATE">
    <ng-container *ngSwitchCase="'LIST'">
      <div class="section-table data-listing">
        <table mat-table [dataSource]="dataSource1" class="mat-elevation-z0">
          <ng-container matColumnDef="Name">
            <th mat-header-cell *matHeaderCellDef>  {{content?.['b2b.managetraveler.name']}}</th>
            <td mat-cell *matCellDef="let element; let i = index"  [ngClass]="{'disabled': (element.status == '0' || element.status == '5')}"><span class="cursor-pointer"
                ><a tabindex="0" role="button" class="onclick-cell primary-link" (click)="(element.status == '0' || element.status == '5')?'':viewInvite(element,i)" data-dd-privacy="mask">{{ formatTitleName(element.name || 'NA' |titlecase) }}</a>
              </span></td>
          </ng-container>
          <ng-container matColumnDef="Relation">
            <th mat-header-cell *matHeaderCellDef>{{content?.['b2b.managetraveler.relation']}}</th>
            <td mat-cell *matCellDef="let element">{{ element.relation || 'NA' }}</td>
          </ng-container>
          <ng-container matColumnDef="Email">
            <th mat-header-cell *matHeaderCellDef>{{content?.['b2b.managetraveler.email']}}</th>
            <td mat-cell *matCellDef="let element" data-dd-privacy="mask">{{ element.email || 'NA' }}</td>
          </ng-container>
          <ng-container matColumnDef="MobileNumber">
            <th mat-header-cell *matHeaderCellDef>{{content?.['b2b.managetraveler.mobileno']}}</th>
            <td mat-cell *matCellDef="let element" data-dd-privacy="mask">{{ element.phoneNo || 'NA' }}</td>
          </ng-container>
          <ng-container matColumnDef="Status">
            <th mat-header-cell *matHeaderCellDef>{{content?.['b2b.managetraveler.status']}}</th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element.status != '0' && element.status != '5'" [ngClass]="`status-chip status-chip-${element.status == '1'?'approved':'approval-pending'}`">
                {{element.status == '4'?(content?.['b2b.managetraveler.approvalpending']):element.status == '2'?'Invite sent':(content?.['b2b.managetraveler.active'])}}
                      </span>
              <span *ngIf="element.status == '0'" class="status-chip status-chip-rejected">
                {{content?.['b2b.managetraveler.rejected'] || 'Rejected'}}
              </span>
              <span *ngIf="element.status == '5'" class="status-chip status-chip-rejected">
                {{content?.['b2b.managetraveler.deactivated'] || 'Deactivated'}}
                </span>
              </td>
          </ng-container>
          <ng-container matColumnDef="Actions">
            <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managetraveler.actions']}} </th>
            <td mat-cell *matCellDef="let element" class="onclick-links"  [ngClass]="{'disabled': (element.status == '0' || element.status == '5')}">
              <a tabindex="0" role="button" class="onclick-cell primary-link" aria-label="Edit item" *ngIf="element.status == '1'" (click)="editDependent(element)"><mat-icon fontSet="material-symbols-outlined">edit</mat-icon></a>
              <a tabindex="0" role="button" class="onclick-cell warm-link" aria-label="Remove item" (click)="openModal(userDeactivateModel,element)"  *ngIf="element.status == '1'"><mat-icon fontSet="material-symbols-outlined">delete</mat-icon></a>
              <ng-template #userDeactivateModel>
                <div class="custom-popup-gen-container">
                  <div class="custom-popup-gen-header">
                    <span class="deactivate-popup-title">{{'Are you sure you want to deactivate this Dependent?'}}</span>
                  </div>
                  <div class="custom-popup-gen-body">
                    <p class="custom-popup-gen-text">
                      {{getDeactivateMsg(element?.name)}}
                    </p>
                  </div>
                  <div class="custom-popup-gen-footer">
                    <div class="btn-group">
                      <button class="button--secondary-small" mat-button (click)="userDeactivateModellRef.close(); callByGtm()">{{dynamicContent?.warningList?.[2]?.cancelCTAText || 'Cancel'}}</button>
                      <button class="button--primary-small-reject" mat-button (click)="DeleteDependent(element)">{{dynamicContent?.warningList?.[2]?.confirmCTAText || 'Deactivate'}}</button>
                    </div>
                  </div>
                </div>
              </ng-template>
              <a tabindex="0" role="button" class="onclick-cell success-link" (click)="resendInvite(element)" *ngIf="element.status == '2'">{{content?.['b2b.managetraveler.resend'] || 'Resend'}}</a>
              <a *ngIf="element.status == '0' || element.status == '4' || element.status == '5'">{{content?.['b2b.managetraveler.resend'] || 'Resend'}}</a>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <div class="custom-pagination" *ngIf="filteredData.length >= 20">
        <button (click)="prevPage()" [disabled]="currentPage === 0">Prev</button>
      
        <span>
          Page {{ currentPage + 1 }} of {{ totalPages }}
        </span>
      
        <button (click)="nextPage()" [disabled]="(currentPage + 1) >= totalPages">Next</button>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'WAITING'">
      <app-waiting></app-waiting>
    </ng-container>
    <ng-container *ngSwitchCase="'EMPTY'">
      <app-cam-empty-state (myEvent)="handleEvent($event)" [heading]="content?.['b2b.managetraveler.nosaveddependenttitle']" [width]="'384px'"
        [content]="content?.['b2b.managetraveler.nosaveddependentdesc']"
        [navigateTo]="'/cam/saved-dependents/dependent-information-form'"> </app-cam-empty-state>
    </ng-container>
  </ng-container>
</form>

